export default __webpack_public_path__ + "static/media/galarie9.a96c74fa.jpg";